import { UploadClient } from "@welearn/upload-client";
import { httpClient } from "./httpClient";
export const uploads = new UploadClient({
  request: <T>(path:string, init:RequestInit={}) => httpClient.request<T>(path,init),
  concurrency:3,
  base:"/admin/banner-images",
});
